import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import $ from "jquery";
import useAlertFromLocation from "../../../../hooks/useAlertFromLocation";
import useDeleteData from "../../../../hooks/useDeleteData";
import ReactDataTable from "../../../Common/ReactDataTable";

const PlanningList = () => {
  const [planningData, setPlanningData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState(""); // State to hold the role
  const [userDepartment, setUserDepartment] = useState(""); // State to hold the role

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 20,
    total: 0,
    from: 0,
    to: 0,
  });

  // Fetch data from /planning API
  const fetchData = async (pageNumber = currentPage, pageSize = perPage) => {
    setLoading(true);
    try {
      // const res = await Http.get("/transfer-list?page=1&per_page=20");
      const res = await Http.get(
        `/transfer-list?page=${pageNumber}&per_page=${pageSize}`,
      );
      const responseData = res.data;
      const transferData = responseData?.data || [];

      setPlanningData(transferData);

      setPagination({
        current_page: responseData?.current_page || pageNumber,
        last_page: responseData?.last_page || 1,
        per_page: responseData?.per_page || pageSize,
        total: responseData?.total || 0,
        from: responseData?.from || 0,
        to: responseData?.to || 0,
      });
      // setPlanningData(dummy);

      Http.get("/staff-type-check").then((res) => {
        setRole(res.data);
      });
      Http.get("/me").then((res) => {
        setUserDepartment(res.data.data.department_art_id);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const loadUserInfo = async () => {
    try {
      const [staffRes, meRes] = await Promise.all([
        Http.get("/staff-type-check"),
        Http.get("/me"),
      ]);

      setRole(staffRes.data);
      setUserDepartment(meRes.data.data.department_art_id);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  useEffect(() => {
    // fetchData();
    loadUserInfo();
    $("body").addClass("collapse-menu");
  }, []);

  useEffect(() => {
    fetchData(currentPage, perPage);
  }, [currentPage, perPage]);

  // Use custom hook to delete data
  const deleteData = useDeleteData(fetchData);
  const alert = useAlertFromLocation();

  const receiveSubmitData = (id, showMsg) => {
    Swal.fire({
      title: "Are you sure You Want to Receive this Item?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, receive it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Http.post("/" + deleteApiUrl + "/" + id + "/cash-count").then((res) => {
        //   setPlanningData(res.data);
        //   Swal.fire("Received!", showMsg + " has been deleted.", "success");
        // });
        Http.post(`/transfer-item-received/${id}`)
          .then((res) => {
            // Swal.fire("Received!", "Item has been received.", "success");
            fetchData(currentPage, perPage);
          })
          .catch(function (e) {
            Swal.fire("Could not receive!", "Could not receive", "danger");
          });
      }
    });
  };

  const accpectSubmitData = (id, showMsg) => {
    Swal.fire({
      title: "Are you sure You Want to Accpect this Item?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Accpect it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Http.post("/" + deleteApiUrl + "/" + id + "/cash-count").then((res) => {
        //   setPlanningData(res.data);
        //   Swal.fire("Received!", showMsg + " has been deleted.", "success");
        // });
        Http.post(`/transfer-item-accpect/${id}`)
          .then((res) => {
            // Swal.fire("Received!", "Item has been received.", "success");
            fetchData(currentPage, perPage);
          })
          .catch(function (e) {
            Swal.fire("Could not receive!", "Could not receive", "danger");
          });
      }
    });
  };

  const rejectSubmitData = (id, showMsg) => {
    Swal.fire({
      title: "Are you sure You Want to Reject this Item?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, reject it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Http.post("/" + deleteApiUrl + "/" + id + "/cash-count").then((res) => {
        //   setPlanningData(res.data);
        //   Swal.fire("Received!", showMsg + " has been deleted.", "success");
        // });
        Http.post(`/transfer-item-reject/${id}`)
          .then((res) => {
            // Swal.fire("Received!", "Item has been received.", "success");
            fetchData(currentPage, perPage);
          })
          .catch(function (e) {
            Swal.fire("Could not receive!", "Could not receive", "danger");
          });
      }
    });
  };

  const produceSubmitData = (id, showMsg) => {
    Swal.fire({
      title: "Are you sure You Want to Produce this Repair Item?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, produce it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.post(`/repair-produced/${id}`)
          .then((res) => {
            Swal.fire("Received!", "Item has been received.", "success");
            fetchData(currentPage, perPage);
          })
          .catch(function (e) {
            Swal.fire("Could not receive!", "Could not receive", "danger");
          });
      }
    });
  };

  const handleMassReceive = async (selectedItems) => {
    Swal.fire({
      title: "Are you sure you want to receive these items?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, receive them!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Create an array of promises for each item
        const receivePromises = selectedItems.map((item) =>
          Http.post(`/transfer-item-received/${item.id}`),
        );

        // Execute all promises
        Promise.all(receivePromises)
          .then(() => {
            // Swal.fire("Received!", "Items have been received.", "success");
            fetchData(currentPage, perPage); // Refresh the data
          })
          .catch(() => {
            Swal.fire("Error!", "Could not receive some items.", "error");
          });
      }
    });
  };

  // Function to check if an item is receivable
  const isItemReceivable = (item) => {
    const isToCurrentDepartment = item.to_department_art_id === userDepartment;

    if (!isToCurrentDepartment) return false;

    // Check if ALL receive quantities are less than 1 based on role
    if (role === "dfw" || role === "decoration_firing") {
      return (
        item.receive_qty_export < 1 &&
        item.receive_qty_a_class < 1 &&
        item.receive_qty_b_class < 1 &&
        item.receive_qty_c_class < 1
      );
    } else if (role === "decoration_local" || role === "packing_local") {
      return (
        item.receive_qty < 1 &&
        item.receive_qty_a_class < 1 &&
        item.receive_qty_b_class < 1 &&
        item.receive_qty_c_class < 1
      );
    } else if (role === "decoration_export" || role === "packing_export") {
      return item.receive_qty < 1 && item.receive_qty_export < 1;
    } else if (role === "sample") {
      return item.receive_master_qty < 1 || item.receive_inner_qty < 1;
    } else {
      // For other roles
      return item.receive_qty < 1;
    }
  };

  // Filter receivable items
  const receivableItems = planningData.filter(isItemReceivable);

  const getRowClassName = (item) => {
    if (item.from_department_art_id === userDepartment) {
      return "bg-light-blue"; // Outgoing transfers
    } else if (item.to_department_art_id === userDepartment) {
      return "bg-light-red"; // Incoming transfers
    }
    return "";
  };

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    const totalPages = pagination.last_page;
    const activePage = pagination.current_page;

    // Show page buttons in groups of 10: 1-10, 11-20, 21-30...
    const pageGroupStart = Math.floor((activePage - 1) / 10) * 10 + 1;
    const pageGroupEnd = Math.min(pageGroupStart + 9, totalPages);

    for (let page = pageGroupStart; page <= pageGroupEnd; page++) {
      buttons.push(
        <button
          key={page}
          type="button"
          className={`btn btn-sm ${
            page === activePage ? "btn-primary" : "btn-outline-primary"
          } mx-1`}
          onClick={() => setCurrentPage(page)}
        >
          {page}
        </button>,
      );
    }

    return buttons;
  };
  const cols = [
    {
      field: "production_finished_good_transfer.receipt_no",
      header: "Receipt No",
      cell: (item) => (
        <div>
          {item.from_department_art_id === userDepartment ? (
            <span className="text-primary">
              ➡️ {item?.production_finished_good_transfer?.receipt_no}
            </span>
          ) : (
            <span className="text-danger">
              ⬇️ {item?.production_finished_good_transfer?.receipt_no}
            </span>
          )}
        </div>
      ),
    },
    {
      field: "product.name",
      header: "Product Name",
      cell: (item) => (
        <div
          className={
            item.from_department_art_id === userDepartment
              ? "text-primary"
              : "text-danger"
          }
        >
          {item?.product?.name}
        </div>
      ),
    },
    {
      // field: "production_work_order.company.name",
      header: "Company",
      field: (item) => (
        <div>
          {item?.production_work_order?.company?.name} #{" "}
          {item?.production_work_order?.receipt_no}
        </div>
      ),
    },
    {
      header: "Planning No",
      field: (item) => <div>{item?.planning?.receipt_no}</div>,
    },

    // {
    //   header: "Kiln",
    //   field: "kiln_type",
    // },

    ...(role === "gk" || role === "admin"
      ? [
          {
            field: (rowData) =>
              rowData.kiln_type == "shuttle_kiln"
                ? "Shuttle Kiln"
                : "Tunnel Kiln",
            header: "Kiln",
          },
        ]
      : []),

    ...(role !== "body" ? [{ field: "shape.name", header: "Shape" }] : []),
    ...(role === "decoration_local" ||
    role === "dfw" ||
    role === "decoration_firing" ||
    role === "decoration_export" ||
    role === "packing_local" ||
    role === "packing_export"
      ? [
          {
            header: "Decoration No",
            field: (item) => (
              <div>
                {item?.production_work_order_item?.decoration
                  ? item?.production_work_order_item?.decoration?.code
                  : item?.decoration_id?.code}
              </div>
            ),
          },
          {
            header: "Decoration Name",
            field: (item) => (
              // <div>{item?.production_work_order_item?.decoration?.decoration_name}</div>
              <div>
                {item?.production_work_order_item?.decoration
                  ? item?.production_work_order_item?.decoration
                      ?.decoration_name
                  : item?.decoration_id?.decoration_name}
              </div>
            ),
          },
        ]
      : []),
    ...(role === "decoration_local" ||
    role === "dfw" ||
    role === "decoration_firing" ||
    role === "decoration_export" ||
    role === "packing_local" ||
    role === "packing_export" ||
    role === "glazing" ||
    role === "gk" ||
    role === "selection"
      ? [
          {
            header: "Colour Name",
            field: (item) => (
              <div>{item?.production_work_order_item?.color?.colour_name}</div>
            ),
          },
        ]
      : []),
    // { field: "delivery_qty", header: "Qty" },
    ...(role === "admin" ||
    (role !== "dfw" &&
      role !== "decoration_firing" &&
      role !== "packing_local" &&
      role !== "packing_export")
      ? [{ field: "delivery_qty", header: "Qty" }]
      : []),
    ...(role === "admin" ||
    role === "body" ||
    role === "jigger" ||
    role === "casting"
      ? [
          {
            field: (item) =>
              item.from_department_art_id === 1 ? item.delivery_qty * 20 : null,
            header: "Totoal Weight",
          },
        ]
      : []),
    ...(role === "admin" ||
    role === "decoration_export" ||
    role === "packing_export" ||
    role === "dfw" ||
    role === "decoration_firing" ||
    role === "selection"
      ? [
          { field: "delivery_qty_export", header: "Qty Exp" },

          // { field: "delivery_master_qty", header: "Master qty" },
          // { field: "delivery_inner_qty", header: "Inner qty" },
        ]
      : []),
    ...(role === "admin" ||
    role === "decoration_local" ||
    role === "packing_local" ||
    role === "dfw" ||
    role === "decoration_firing" ||
    role === "selection"
      ? [
          { field: "delivery_qty_a_class", header: "Qty A" },
          { field: "delivery_qty_b_class", header: "Qty B" },
          { field: "delivery_qty_c_class", header: "Qty C" },
          // { field: "delivery_master_qty", header: "Master qty" },
          // { field: "delivery_inner_qty", header: "Inner qty" },
        ]
      : []),
    ...(role === "admin" ||
    role === "sample" ||
    role === "packing_export" ||
    role === "packing_local"
      ? [
          // { field: "delivery_qty_a_class", header: "Qty A" },
          // { field: "delivery_qty_b_class", header: "Qty B" },
          // { field: "delivery_qty_c_class", header: "Qty C" },
          { field: "delivery_master_qty", header: "Master qty" },
          { field: "delivery_inner_qty", header: "Inner qty" },
        ]
      : []),
    {
      field: "production_finished_good_transfer.transfer_date",
      header: "Tr Date",
    },
    {
      field: "receive_date",
      header: "Rec Date",
    },
    {
      field: "from_department_art.name",
      header: "From",
      cell: (item) => (
        <div
          className={
            item.from_department_art_id === userDepartment
              ? "fw-bold text-primary"
              : ""
          }
        >
          {item.from_department_art.name}
        </div>
      ),
    },
    {
      field: "to_department_art.name",
      header: "To",
      cell: (item) => (
        <div
          className={
            item.to_department_art_id === userDepartment
              ? "fw-bold text-danger"
              : ""
          }
        >
          {item.to_department_art.name}
        </div>
      ),
    },
    ...(role !== "admin" || role !== "demo"
      ? [
          {
            field: (item) => {
              if (item.from_department_art_id === userDepartment) {
                return (
                  <div className="d-flex align-items-center">
                    {/* <span className="badge bg-primary me-1">Outgoing</span> */}
                    {(role !== "dfw" &&
                      role !== "decoration_firing" &&
                      role !== "decoration_local" &&
                      role !== "packing_local" &&
                      role !== "decoration_export" &&
                      role !== "packing_export" &&
                      role !== "selection" &&
                      item.receive_qty < 1) ||
                    ((role === "dfw" ||
                      role === "decoration_firing" ||
                      role === "selection") &&
                      item.receive_qty_export < 1 &&
                      item.receive_qty_a_class < 1 &&
                      item.receive_qty_b_class < 1 &&
                      item.receive_qty_c_class < 1) ||
                    ((role === "decoration_local" ||
                      role === "packing_local") &&
                      item.receive_qty < 1 &&
                      item.receive_qty_a_class < 1 &&
                      item.receive_qty_b_class < 1 &&
                      item.receive_qty_c_class < 1) ||
                    ((role === "decoration_export" ||
                      role === "packing_export" ||
                      role === "sample") &&
                      item.receive_qty_export < 1) ? (
                      <span className="badge bg-info">Delivered</span>
                    ) : role == "sample" &&
                      item.is_reject == 1 &&
                      item.is_accept == null ? (
                      <span className="badge bg-danger">Reject</span>
                    ) : (
                      <span className="badge bg-success">Received</span>
                    )}
                  </div>
                );
              } else if (item.to_department_art_id === userDepartment) {
                return (
                  <div className="d-flex align-items-center">
                    {/* <span className="badge bg-danger me-1">Incoming</span> */}
                    {(role !== "dfw" &&
                      role !== "decoration_firing" &&
                      role !== "decoration_local" &&
                      role !== "decoration_export" &&
                      role !== "packing_local" &&
                      role !== "packing_export" &&
                      item.receive_qty < 1) ||
                    (role === "dfw" &&
                      item.receive_qty_export < 1 &&
                      item.receive_qty_a_class < 1 &&
                      item.receive_qty_b_class < 1 &&
                      item.receive_qty_c_class < 1) ||
                    (role === "decoration_firing" &&
                      item.receive_qty < 1 &&
                      item.receive_qty_export < 1 &&
                      item.receive_qty_a_class < 1 &&
                      item.receive_qty_b_class < 1 &&
                      item.receive_qty_c_class < 1 &&
                      item.to_department_art_id === userDepartment) ||
                    (role === "decoration_local" &&
                      item.receive_qty < 1 &&
                      item.receive_qty_a_class < 1 &&
                      item.receive_qty_b_class < 1 &&
                      item.receive_qty_c_class < 1 &&
                      item.to_department_art_id === userDepartment) ||
                    (role === "packing_local" &&
                      item.receive_master_qty < 1 &&
                      item.receive_inner_qty < 1 &&
                      item.receive_qty < 1 &&
                      item.receive_qty_a_class < 1 &&
                      item.receive_qty_b_class < 1 &&
                      item.receive_qty_c_class < 1 &&
                      item.to_department_art_id === userDepartment) ||
                    (role === "packing_export" &&
                      item.receive_master_qty < 1 &&
                      item.receive_inner_qty < 1 &&
                      item.receive_qty < 1 &&
                      item.receive_qty_export < 1 &&
                      item.to_department_art_id === userDepartment) ||
                    (role === "sample" &&
                      (item.receive_master_qty < 1 ||
                        item.receive_inner_qty < 1) &&
                      item.to_department_art_id === userDepartment) ||
                    (role === "decoration_export" &&
                      item.receive_qty < 1 &&
                      item.receive_qty_export < 1 &&
                      item.to_department_art_id === userDepartment) ? (
                      <span className="badge bg-warning">Pending</span>
                    ) : role == "sample" &&
                      item.is_reject == 1 &&
                      item.is_accept == null ? (
                      <span className="badge bg-danger">Reject</span>
                    ) : (
                      <span className="badge bg-success">Received</span>
                    )}
                  </div>
                );
              } else {
                // Default fallback (if neither department matches)
                return <span className="badge bg-secondary">Unknown</span>;
              }
            },
            header: " Status ",
          },
        ]
      : []),
    ...(role !== "admin" || role !== "demo"
      ? [
          {
            field: (item) => (
              <div className="text-xs text-nowrap">
                {item.production == null &&
                item.to_department_art_id === userDepartment &&
                item.is_repair == 1 &&
                item.receive_qty > 1 ? (
                  <button
                    className="btn btn-warning btn-sm ms-1"
                    onClick={() => produceSubmitData(item.id)}
                  >
                    <i className="fa fa-cogs"></i> Produce
                  </button>
                ) : (role !== "dfw" &&
                    role !== "decoration_firing" &&
                    role !== "decoration_local" &&
                    role !== "packing_local" &&
                    role !== "decoration_export" &&
                    role !== "packing_export" &&
                    role !== "sample" &&
                    item.receive_qty < 1 &&
                    item.to_department_art_id === userDepartment) ||
                  (role === "sample" &&
                    (item.receive_master_qty < 1 ||
                      item.receive_inner_qty < 1) &&
                    item.to_department_art_id === userDepartment) ||
                  (role === "dfw" &&
                    item.receive_qty_export < 1 &&
                    item.receive_qty_a_class < 1 &&
                    item.receive_qty_b_class < 1 &&
                    item.receive_qty_c_class < 1 &&
                    item.to_department_art_id === userDepartment) ||
                  (role === "decoration_firing" &&
                    item.receive_qty < 1 &&
                    item.receive_qty_export < 1 &&
                    item.receive_qty_a_class < 1 &&
                    item.receive_qty_b_class < 1 &&
                    item.receive_qty_c_class < 1 &&
                    item.to_department_art_id === userDepartment) ||
                  (role === "decoration_local" &&
                    item.receive_qty < 1 &&
                    item.receive_qty_a_class < 1 &&
                    item.receive_qty_b_class < 1 &&
                    item.receive_qty_c_class < 1 &&
                    item.to_department_art_id === userDepartment) ||
                  (role === "packing_local" &&
                    item.receive_master_qty < 1 &&
                    item.receive_inner_qty < 1 &&
                    item.receive_qty < 1 &&
                    item.receive_qty_a_class < 1 &&
                    item.receive_qty_b_class < 1 &&
                    item.receive_qty_c_class < 1 &&
                    item.to_department_art_id === userDepartment) ||
                  (role === "packing_export" &&
                    item.receive_master_qty < 1 &&
                    item.receive_inner_qty < 1 &&
                    item.receive_qty < 1 &&
                    item.receive_qty_export < 1 &&
                    item.to_department_art_id === userDepartment) ||
                  (role === "decoration_export" &&
                    item.receive_qty < 1 &&
                    item.receive_qty_export < 1 &&
                    item.to_department_art_id === userDepartment) ? (
                  <>
                    <button
                      className="btn btn-primary btn-sm ms-1"
                      onClick={() => receiveSubmitData(item.id)}
                      title="Receive"
                    >
                      <i className="fa fa-send"></i> Receive
                    </button>
                    {/* <Link
                      to={`/edit-transfer/${item.id}`}
                      className="btn btn-secondary btn-sm ms-1"
                    >
                      <i className="fa fa-bars"></i>View
                    </Link> */}
                  </>
                ) : (role !== "dfw" &&
                    role !== "decoration_firing" &&
                    role !== "decoration_local" &&
                    role !== "packing_local" &&
                    role !== "decoration_export" &&
                    role !== "packing_export" &&
                    role !== "selection" &&
                    role !== "sample" &&
                    item.receive_qty < 1) ||
                  // (role === "sample" &&
                  //   (item.receive_master_qty < 1 || item.receive_inner_qty < 1) &&
                  //   item.to_department_art_id === userDepartment) ||
                  ((role === "dfw" ||
                    role === "decoration_firing" ||
                    role === "selection") &&
                    item.receive_qty_export < 1 &&
                    item.receive_qty_a_class < 1 &&
                    item.receive_qty_b_class < 1 &&
                    item.receive_qty_c_class < 1 &&
                    item.from_department_art_id === userDepartment) ||
                  (role === "decoration_local" &&
                    item.receive_qty_a_class < 1 &&
                    item.receive_qty_b_class < 1 &&
                    item.receive_qty_c_class < 1 &&
                    item.from_department_art_id === userDepartment) ||
                  ((role === "packing_export" || role === "packing_local") &&
                    item.receive_qty_a_class < 1 &&
                    item.receive_qty_b_class < 1 &&
                    item.receive_qty_c_class < 1 &&
                    item.receive_master_qty < 1 &&
                    item.receive_inner_qty < 1 &&
                    item.from_department_art_id === userDepartment) ||
                  (role === "sample" &&
                    (item.delivery_master_qty > 0 ||
                      item.delivery_inner_qty > 0) &&
                    item.from_department_art_id === userDepartment) ||
                  (role === "decoration_export" &&
                    item.receive_qty_export < 1 &&
                    item.from_department_art_id === userDepartment) ? (
                  <>
                    {role === "packing_local" ||
                    role === "packing_export" ||
                    role === "sample" ? (
                      // {(role === "dfw" || role === "decoration_firing") && (
                      <>
                        <i>Delivered</i> &nbsp;
                        {/* <Link
                    to={`/edit-production-jigcast-decoration-tr/req-art/${item.production_finished_good_transfer_id}`}
                    className="btn btn-secondary btn-sm ms-1"
                  >
                    <i className="fa fa-edit"></i> Edit
                  </Link> */}
                      </>
                    ) : (
                      <>
                        <i>Pending</i> &nbsp;
                        {/* {role === "body" ? (
                <Link
                  to={`/edit-department-transfer/${item.id}`}
                  className="btn btn-secondary btn-sm ms-1"
                >
                  <i className="fa fa-edit"></i> Edit
                </Link>
              ) : (
                <Link
                  to={`/edit-transfer-uu/${item.id}`}
                  className="btn btn-secondary btn-sm ms-1"
                >
                  <i className="fa fa-edit"></i> Edit
                </Link>
              )} */}
                        {/* {role === "body" && (
                <Link
                  to={`/edit-department-transfer/${item.id}`}
                  className="btn btn-secondary btn-sm ms-1"
                >
                  <i className="fa fa-edit"></i> Edit
                </Link>
              )} */}
                        {/* {(role === "finishing" ||
                role === "bk" ||
                role === "glazing" ||
                role === "gk") && (
                <Link
                  to={`/edit-production-jigcast-till-selection/req-art/${item.production_finished_good_transfer_id}`}
                  className="btn btn-secondary btn-sm ms-1"
                >
                  <i className="fa fa-edit"></i> Edit
                </Link>
              )} */}
                        {/* {(role === "selection" || role === "dfw" || role === "decoration_firing") && (
                <Link
                  to={`/edit-production-jigcast-selection-tr/req-art/${item.production_finished_good_transfer_id}`}
                  className="btn btn-secondary btn-sm ms-1"
                >
                  <i className="fa fa-edit"></i> Edit
                </Link>
              )} */}
                      </>
                    )}

                    {/* {!(
                role === "body" ||
                role === "finishing" ||
                role === "bk" ||
                role === "glazing" ||
                role === "gk" ||
                role === "selection" ||
                role === "decoration_local" ||
                role === "decoration_export" ||
                role === "dfw" ||
                role === "decoration_firing" ||
                role === "packaging_local" ||
                role === "packaging_export"
              ) && (
                <Link
                  to={`/edit-transfer-uu/${item.id}`}
                  className="btn btn-secondary btn-sm ms-1"
                >
                  <i className="fa fa-edit"></i> Edit
                </Link>
              )} */}
                  </>
                ) : item.is_reject == 1 && item.is_accept == null ? (
                  <>
                    <i
                      className="fa fa-times"
                      style={{ color: "red", fontWeight: "bold" }}
                    >
                      {" "}
                      Reject
                    </i>
                  </>
                ) : item.is_reject == null && item.is_accept == 1 ? (
                  <>
                    <i
                      className="fa fa-check"
                      style={{ color: "green", fontWeight: "bold" }}
                    >
                      {" "}
                      Accpected
                    </i>
                  </>
                ) : role === "sample" &&
                  item.is_reject == null &&
                  item.is_accept == null &&
                  (item.receive_master_qty < 1 || item.receive_inner_qty < 1) &&
                  item.from_department_art_id !== userDepartment ? (
                  <>
                    <button
                      className="btn btn-info btn-sm ms-1"
                      onClick={() => accpectSubmitData(item.id)}
                      title="Accpect"
                    >
                      <i className="fa fa-check"></i> Accpect
                    </button>
                    <button
                      className="btn btn-danger btn-sm ms-1"
                      onClick={() => rejectSubmitData(item.id)}
                      title="Reject"
                    >
                      <i className="fa fa-times"></i> Reject
                    </button>
                  </>
                ) : (
                  <>
                    <i
                      className="fa fa-check"
                      style={{ color: "green", fontWeight: "bold" }}
                    >
                      {" "}
                      Received
                    </i>
                    {/* <Link
                      to={`/edit-transfer-uu/${item.id}`}
                      className="btn btn-secondary btn-sm ms-1"
                    >
                      <i className="fa fa-bars"></i>View
                    </Link> */}
                  </>
                )}
              </div>
            ),
            header: "Actions",
          },
        ]
      : []),
  ];

  return (
    <div>
      <IsLogin />
      <style>
        {`
          .bg-light-blue {
            background-color: rgba(13, 110, 253, 0.1) !important;
          }
          .bg-light-red {
            background-color: rgba(220, 53, 69, 0.1) !important;
          }
          /* Override striped rows */
          .p-datatable-striped .p-datatable-tbody > tr.bg-light-blue {
            background-color: rgba(13, 110, 253, 0.1) !important;
          }
          .p-datatable-striped .p-datatable-tbody > tr.bg-light-red {
            background-color: rgba(220, 53, 69, 0.1) !important;
          }
        `}
      </style>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">All Transfers</h5>
          {role === "jigger" && (
            <Link
              to="/create-delivery-jig/req-art"
              className="btn btn-primary"
              title="Production"
            >
              <i className="fa fa-plus-square mg-r-6"></i> Production
            </Link>
          )}
          {role === "casting" && (
            <Link
              to="/create-delivery-jigcast/req-art"
              className="btn btn-primary"
              title="Production"
            >
              <i className="fa fa-plus-square mg-r-6"></i> Production
            </Link>
          )}
          {(role === "finishing" ||
            role === "bk" ||
            role === "glazing" ||
            role === "gk") && (
            <Link
              to="/create-delivery-jigcast-till-selection/req-art"
              className="btn btn-primary"
              title="Production"
            >
              <i className="fa fa-plus-square mg-r-6"></i> Production
            </Link>
          )}
          {/* {(role === "glazing" || role === "gk") && (
            <Link
              to="/create-delivery-glazing-gk/req-art"
              className="btn btn-primary"
              title="Production"
            >
              <i className="fa fa-plus-square mg-r-6"></i> Production
            </Link>
          )} */}
          {(role === "selection" ||
            role === "dfw" ||
            role === "decoration_firing") && (
            <div>
              {/* <Link
                to="/create-delivery-jigcast-selection-tr/req-art"
                className="btn btn-success me-4"
              >
                <i className="fa fa-paper-plane"></i> Transfer
              </Link> */}
              {role === "selection" && (
                <Link
                  to="/create-delivery-jigcast-selection/req-art"
                  className="btn btn-primary"
                  title="Production"
                >
                  <i className="fa fa-plus-square mg-r-6"></i> Production
                </Link>
              )}
              {/* {(role === "dfw" || role === "decoration_firing") && (
                <Link
                to="/create-delivery-jigcast-decoration/req-art"
                className="btn btn-primary"
              >
                <i className="fa fa-plus-square mg-r-6"></i> Production
              </Link>
              )} */}
            </div>
          )}
          {(role === "decoration_local" ||
            role === "decoration_export" ||
            role === "packing_local" ||
            role === "packing_export" ||
            role === "sample" ||
            role === "decoration_firing") && (
            <Link
              to="/create-delivery-jigcast-decoration/req-art"
              className="btn btn-primary"
              title="Production"
            >
              <i className="fa fa-plus-square mg-r-6"></i> Production
            </Link>
          )}
        </div>
        <div className="am-pagebody">
          <Alert alert={alert} />
          <div className="card pd-20 pd-sm-40">
            <ReactDataTable
              cols={cols}
              receiveData={planningData}
              isLoading={loading}
              enableMassReceive={receivableItems.length > 0}
              onMassReceive={handleMassReceive}
              selection={receivableItems}
              rowClassName={getRowClassName}
              userDepartment={userDepartment}
              role={role}
            />
            <div className="row align-items-center mt-3">
              <div className="col-md-3 mb-2">
                Showing {pagination.from || 0} to {pagination.to || 0} of{" "}
                {pagination.total || 0} entries
              </div>

              <div className="col-md-6 mb-2">
                <div className="d-flex justify-content-center align-items-center flex-wrap">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary mx-1"
                    disabled={pagination.current_page <= 1}
                    onClick={() => setCurrentPage(1)}
                  >
                    First
                  </button>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary mx-1"
                    disabled={pagination.current_page <= 1}
                    onClick={() => setCurrentPage(pagination.current_page - 1)}
                  >
                    Prev
                  </button>

                  {renderPaginationButtons()}

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary mx-1"
                    disabled={pagination.current_page >= pagination.last_page}
                    onClick={() => setCurrentPage(pagination.current_page + 1)}
                  >
                    Next
                  </button>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary mx-1"
                    disabled={pagination.current_page >= pagination.last_page}
                    onClick={() => setCurrentPage(pagination.last_page)}
                  >
                    Last
                  </button>
                </div>
              </div>

              <div className="col-md-3 mb-2">
                <div className="d-flex justify-content-md-end align-items-center">
                  <span className="me-2">Per Page</span>

                  <select
                    className="form-control form-control-sm"
                    style={{ width: "90px" }}
                    value={perPage}
                    onChange={handlePerPageChange}
                  >
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                    <option value={500}>500</option>
                    <option value={1000}>1000</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanningList;
